import { Injectable } from "@angular/core";
import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
	HttpResponse,
} from "@angular/common/http";
import { Observable, of } from "rxjs";
import { delay } from "rxjs/operators";
import {
	getMockDelayMs,
	isPerformanceMockEnabled,
	PERFORMANCE_API_BASE,
} from "./mock-config";
import { PerformanceMockDb } from "./performance-mock.db";
import { matchRoute } from "./performance-mock.routes";

/**
 * Simulador de API (mock backend) del módulo de desempeño.
 *
 * Intercepta las requests cuya URL apunta al backend de desempeño
 * ({@link PERFORMANCE_API_BASE}) y las responde con data mock (con latencia
 * configurable) mientras el backend real se construye.
 *
 * Para apuntar al backend real basta poner `MOCK_PERFORMANCE_API: false` en
 * `environment.ts`: el interceptor deja pasar la request tal cual
 * (`next.handle(req)`) sin tocar servicios ni vistas, que ya llaman a la URL real.
 */
@Injectable()
export class PerformanceMockInterceptor implements HttpInterceptor {
	/** Store en memoria único; vive mientras dure la sesión (hasta recargar). */
	private readonly db = new PerformanceMockDb();

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Mock apagado o URL ajena al módulo de desempeño -> backend real.
		if (!isPerformanceMockEnabled() || !req.url.startsWith(PERFORMANCE_API_BASE)) {
			return next.handle(req);
		}

    console.log("*-* request:: ", req.url)

		// Path relativo a la base, sin query string.
		const [pathWithBase] = req.url.split("?");
		const relativePath = pathWithBase.slice(PERFORMANCE_API_BASE.length).replace(/^\/+|\/+$/g, "");
		const query = new URLSearchParams(req.url.split("?")[1] || "");

		const matched = matchRoute(req.method, relativePath);

		if (!matched) {
			// Endpoint del módulo aún no simulado: avisar y responder 404 mock para
			// no golpear la red y detectar fácilmente qué falta agregar a las rutas.
			console.warn(
				`[PerformanceMock] Sin handler para ${req.method} ${relativePath}. ` +
					`Agrega la ruta en performance-mock.routes.ts.`,
			);
			return of(
				new HttpResponse({
					status: 404,
					url: req.url,
					body: { message: "lili: Mock endpoint no implementado", path: relativePath },
				}),
			).pipe(delay(getMockDelayMs()));
		}

		const body = matched.route.handler({ req, params: matched.params, query, db: this.db });
    console.log("*_* body mock de interceptor", body)

		return of(new HttpResponse({ status: 200, url: req.url, body })).pipe(delay(getMockDelayMs()));
	}
}
